import { render } from "./Dropdown1.vue?vue&type=template&id=19db5d9e"
import script from "./Dropdown1.vue?vue&type=script&lang=js"
export * from "./Dropdown1.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__